module.exports = __webpack_public_path__ + "img/a17d895.png";